import { IS_START_TOUR , HIDE_SHOW_DEFAULT_TOUR } from "../actions/actionConstants";

const initialState = {
    isStartTour:false,
    isNewUser : false,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case IS_START_TOUR: {
            return Object.assign({}, state, {isStartTour:action.payload});
        }
        case HIDE_SHOW_DEFAULT_TOUR: {
            return Object.assign({}, state, {isNewUser:action.payload});
        }

        default:
            return state;
    }
}